import React from "react";
import { useTranslation } from "react-i18next";
import { FlightFixture } from "./types";

export interface FeedUnavailableCardProps {
  fixture: FlightFixture;
  onRetry: () => void;
}

export const FeedUnavailableCard: React.FC<FeedUnavailableCardProps> = ({
  fixture,
  onRetry,
}) => {
  const { t } = useTranslation("flightAlerts");
  const isArrival = fixture.direction === "arrival";

  return (
    <div className="rounded-xl bg-white p-6 shadow-sm flex flex-col gap-4">
      <span
        className={`inline-flex w-fit items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold text-white ${
          isArrival ? "bg-neutral-900" : "bg-flight-blue"
        }`}
      >
        {isArrival ? t("flight.badgeArriving") : t("flight.badgeDeparting")}
      </span>

      <div>
        <h2 className="text-xl font-bold text-neutral-900">{fixture.flightNumber}</h2>
        <p className="text-sm text-mineshaft-700">
          {isArrival
            ? t("results.arrivalSubtitle", {
                airport: fixture.otherAirport,
                hall: fixture.hall ?? "—",
                date: fixture.dateDisplay,
              })
            : t("results.departureSubtitle", {
                airport: fixture.otherAirport,
                date: fixture.dateDisplay,
              })}
        </p>
      </div>

      <div className="rounded-lg bg-flight-red-bg px-4 py-3 text-sm text-flight-red">
        {t("results.feedUnavailableBody")}
      </div>

      <div className="flex items-end gap-4">
        <div className="flex flex-col">
          <span className="text-xs text-mineshaft-700">
            {isArrival
              ? t("results.scheduledLabelArrival")
              : t("results.scheduledLabelDeparture")}
          </span>
          <span className="text-2xl font-bold text-gray-300">—</span>
        </div>
        <span className="text-gray-300 pb-1">→</span>
        <div className="flex flex-col">
          <span className="text-xs text-mineshaft-700">
            {isArrival
              ? t("results.estimatedLabelArrival")
              : t("results.estimatedLabelDeparture")}
          </span>
          <span className="text-2xl font-bold text-gray-300">—</span>
        </div>
      </div>

      <button
        type="button"
        onClick={onRetry}
        className="rounded-lg bg-brand-blue py-3 text-center text-base font-semibold text-white"
      >
        {t("shared.tryAgain")}
      </button>
      <p className="text-xs text-mineshaft-700">{t("results.feedUnavailableNote")}</p>
    </div>
  );
};
